module.exports = __webpack_public_path__ + "static/media/Stellar Ark Single Headboard - 120 cm_Grey.4aef9a13.png";